/**
 * Select 옵션
 * --
 */
const SelectOption = {
  /**
   * 진열상태
   * --
   */
  DISPLAY_OPTION: [
    {
      label: '전시상태',
      value: '',
    },
    { label: '전시함', value: 'Y' },
    { label: '전시안함', value: 'N' },
  ],

  /**
   * 판매상태
   * --
   */
  SALE_OPTION: [
    {
      label: '판매상태',
      value: '',
    },
    { label: '판매함', value: 'Y' },
    { label: '판매안함', value: 'N' },
  ],
};

export default SelectOption;
